import { Component, OnInit } from "@angular/core";
import {
  startWith,
  switchMap,
  map,
  catchError,
  finalize,
} from "rxjs/operators";
import { merge, Observable, of as observableOf } from "rxjs";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { Router } from "@angular/router";
import { PageDashboardDossierCredit } from "../../../core/model/PageDashboardDossierCredit";
import { NewDashboardDirectionService } from "src/app/new-dashboard/core/service/new-dashboard-direction.service";

@Component({
  selector: "app-credit-dossiers-card",
  templateUrl: "./dossiers-card.component.html",
  styleUrls: ["./dossiers-card.component.scss"]
})
export class DossiersCardComponent implements OnInit {
  paginatedEnCoursItems: PageDashboardDossierCredit;
  paginatedEnRetardItems: PageDashboardDossierCredit;
  paginatedMiseEnPlaceItems: PageDashboardDossierCredit;
  paginatedEnCorrectionItems: PageDashboardDossierCredit;
  isLoadingResults = true;
  filter: string;


  pageSize: number = 5; // Number of items to display per page
  pageEnCoursIndex: number = 0; // Number of
  pageEnRetardIndex: number = 0;
  pageMiseEnPlaceIndex: number = 0;
  pageEnCorrectionIndex: number = 0;

  //Loader par cardView
  isLoadingEnCours: boolean = false;
  isLoadingEnRetard: boolean = false;
  isLoadingMiseEnPlace: boolean = false;
  isLoadingEnCorrection: boolean = false;

  formulaire: FormulaireDTO;
  codeDirection: string = "DIRECTION_RISQUE";


  constructor(
    private _router: Router,  
    private _dashboardDirectionService: NewDashboardDirectionService,
    private _formulaireService: FormulaireService
  ) {}

  ngOnInit() {
    this.getDossiersCreditEnCours("", 0);
    this.getDossiersCreditEnRetard("", 0);
    this.getDossiersCreditMiseEnPlace("", 0);
    this.getDossiersCreditEnCorrection("", 0);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue.trim().toLowerCase();
    this.pageEnCoursIndex = 0; // Number of
    this.pageEnRetardIndex = 0;
    this.pageMiseEnPlaceIndex = 0;
    this.pageEnCorrectionIndex = 0;
    this.getDossiersCreditEnCours(this.filter, this.pageEnCoursIndex);
    this.getDossiersCreditEnRetard(this.filter, this.pageEnRetardIndex);
    this.getDossiersCreditMiseEnPlace(this.filter, this.pageMiseEnPlaceIndex);
    this.getDossiersCreditEnCorrection(this.filter, this.pageEnCorrectionIndex);
  }
  pageSizeChanged() {
    this.pageEnCoursIndex = 0; // Number of
    this.pageEnRetardIndex = 0;
    this.pageMiseEnPlaceIndex = 0;
    this.pageEnCorrectionIndex = 0;
    this.getDossiersCreditEnCours(this.filter, this.pageEnCoursIndex);
    this.getDossiersCreditEnRetard(this.filter, this.pageEnRetardIndex);
    this.getDossiersCreditMiseEnPlace(this.filter, this.pageMiseEnPlaceIndex);
    this.getDossiersCreditEnCorrection(this.filter, this.pageEnCorrectionIndex);
  }

  goToPageEnCours(page: number) {
    if (page >= 0) {
      this.pageEnCoursIndex = page;
      this.getDossiersCreditEnCours(this.filter, page);
    }
  }

  goToPageEnRetard(page: number) {
    if (page >= 0) {
      this.pageEnRetardIndex = page;
      this.getDossiersCreditEnRetard(this.filter, page);
    }
  }

  goToPageMiseEnPlace(page: number) {
    if (page >= 0) {
      this.pageMiseEnPlaceIndex = page;
      this.getDossiersCreditMiseEnPlace(this.filter, page);
    }
  }

  goToPageEnCorrection(page: number) {
    if (page >= 0) {
      this.pageEnCorrectionIndex = page;
      this.getDossiersCreditEnCorrection(this.filter, page);
    }
  }
  getDossiersCreditEnCours(filter: string, page: number): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.isLoadingEnCours = true;
          const actualFilter = filter !== undefined ? filter : "";
          return this._dashboardDirectionService.getDossiersDirectionEnCours(
            this.codeDirection,
            actualFilter,
            page,
            this.pageSize
          );
        }),
        map((data: PageDashboardDossierCredit) => {
          return data;
        }),
        catchError(() => observableOf(null)),
        finalize(() => {
          this.isLoadingEnCours = false;
          this.isLoadingResults = false;
        })
      )
      .subscribe((data) => {
        this.paginatedEnCoursItems = data;
      });
  }

 

  getDossiersCreditEnRetard(filter: string, page: number): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.isLoadingEnRetard = true;
          const actualFilter = filter !== undefined ? filter : "";
          return this._dashboardDirectionService.getDossiersDirectionEnRetard(
            this.codeDirection,
            actualFilter,
            page,
            this.pageSize
          );
        }),
        map((data: PageDashboardDossierCredit) => {
          return data;
        }),
        catchError(() => observableOf(null)),
        finalize(() => {
          this.isLoadingResults = false;
          this.isLoadingEnRetard = false;
        })
      )
      .subscribe((data) => {
        console.log(data);
        this.paginatedEnRetardItems = data;
      });
  }

  getDossiersCreditMiseEnPlace(filter: string, page: number): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.isLoadingMiseEnPlace = true;
          const actualFilter = filter !== undefined ? filter : "";
          return this._dashboardDirectionService.getDossiersDirectionMiseEnPlace(
            this.codeDirection,
            actualFilter,
            page,
            this.pageSize
          );
        }),
        map((data: PageDashboardDossierCredit) => {
          return data;
        }),
        catchError(() => observableOf(null)),
        finalize(() => {
          this.isLoadingResults = false;
          this.isLoadingMiseEnPlace = false;
        })
      )
      .subscribe((data) => {
        console.log(data);
        this.paginatedMiseEnPlaceItems = data;
        console.log("paginatedEnCoursItems");
        console.log(this.paginatedMiseEnPlaceItems);
      });
  }


  getDossiersCreditEnCorrection(filter: string, page: number): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.isLoadingEnCorrection = true;
          const actualFilter = filter !== undefined ? filter : "";
          return this._dashboardDirectionService.getDossiersDirectionEnCorrection(
            this.codeDirection,
            actualFilter,
            page,
            this.pageSize
          );
        }),
        map((data: PageDashboardDossierCredit) => {
          return data;
        }),
        catchError(() => observableOf(null)),
        finalize(() => {
          this.isLoadingResults = false;
          this.isLoadingEnCorrection = false;
        })
      )
      .subscribe((data) => {
        this.paginatedEnCorrectionItems = data;
      });
  }



  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      data => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      error => {
        console.log(error);
      }
    );
  }
}
